import { createReducer } from 'utils/helpers';
import { DashboardMaintenanceEnquiryActionTypes, IActions } from './DashboardMaintenanceEnquiry.actions';

export interface IState {
    DashboardId: number;
}

export const initialState: IState = {
    DashboardId: 0,
};

type IAction = (state: IState, payload: any) => IState;

type IActionMap = Record<DashboardMaintenanceEnquiryActionTypes, IAction>;

const actionMap: IActionMap = {
    [DashboardMaintenanceEnquiryActionTypes.setDashboardId]: (state: IState, payload: IState['DashboardId']): IState => ({ ...state, DashboardId: payload }),
};

export default createReducer<IActionMap, IState, IActions>(actionMap);
